import { useLoadingProgress } from './PreloadContext';

export const StartingScreen = ({ started, onStarted }) => {
    const { progress = 0 } = useLoadingProgress();
    console.log("StartingScreen:", { progress, started });
    
    const isLoaded = progress >= 95;
    const displayProgress = Math.round(progress || 0);
    
    return (
        <div className="loadingScreen">
            <div className="loadingScreen__board">
                <div className={`loadingScreen__progress ${isLoaded ? 'hidden' : ''}`}>
                    <p className="loadingScreen__text">Loading... {displayProgress}%</p>
                    <div
                        className="loadingScreen__progress__value"
                        style={{
                            width: `${displayProgress}%`,
                        }}
                    />
                </div>

                {(started && isLoaded) && (
                    <button
                        className={`loadingScreen__button ${isLoaded ? 'visible' : ''}`}
                        onClick={onStarted}
                    >
                        Start
                    </button>
                )}
            </div>
        </div>
    );
};

